import React, { ChangeEvent, MouseEvent, PureComponent } from 'react';
import styled from 'styled-components';
import { Button, Colors, Grid } from '@inplayer-org/inplayer-ui';

// components
import BoxItemAdder from 'components/BoxItemAdder';
import TextInput from 'components/TextInput';

const { Container, Cell } = Grid;

const EditModeWrapper = styled(Container)`
  width: 100%;
  height: 100%;
  padding: 3rem 1rem;
  border: 1px solid ${Colors.gray};
`;

interface OwnProps {
  itemTitle: string;
  handleAddNew: (name: string) => void;
}

interface State {
  editMode: boolean;
  name: string;
}

class AppBoxAdder extends PureComponent<OwnProps, State> {
  selfRef: React.RefObject<HTMLDivElement> = React.createRef();

  state: State = { editMode: false, name: '' };

  componentDidMount() {
    document.addEventListener('mousedown', this.onClickAway, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.onClickAway, false);
  }

  onClickAway = (e: Event) => {
    const { target } = e;
    const { current: selfNode } = this.selfRef;

    if (!selfNode || !target || selfNode.contains(target as Node)) {
      return;
    }

    this.exitEditMode();
  };

  enterEditMode = () => {
    this.setState({ editMode: true, name: '' });
  };

  exitEditMode = () => {
    this.setState({ editMode: false });
  };

  onEditName = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
    this.setState({ name: value });
  };

  createNew = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    const { handleAddNew } = this.props;
    const { name } = this.state;

    handleAddNew(name);

    this.exitEditMode();
  };

  validateName = (name?: string) => !!name;

  render() {
    const { itemTitle } = this.props;
    const { editMode, name } = this.state;

    if (editMode) {
      return (
        <EditModeWrapper columns={2} rows="content-min auto" ref={this.selfRef}>
          <Cell width={2}>
            <TextInput
              tag="text_input_name_your_app"
              autoFocus
              size="sm"
              placeholder="Name your app"
              onChange={this.onEditName}
              onEnterKey={this.createNew}
              onEscapeKey={this.exitEditMode}
              validationOnEnter={this.validateName}
            />
          </Cell>
          <Cell top={2}>
            <Button
              tag="button_create"
              type="button"
              size="sm"
              fullWidth
              buttonModifiers={['buttonPrimary']}
              onClick={this.createNew}
              disabled={!name}
            >
              Create
            </Button>
          </Cell>
          <Cell top={2}>
            <Button tag="button_cancel" type="button" size="sm" fullWidth onClick={this.exitEditMode}>
              Cancel
            </Button>
          </Cell>
        </EditModeWrapper>
      );
    }

    return <BoxItemAdder itemTitle={itemTitle} handleAddNew={this.enterEditMode} />;
  }
}

export default AppBoxAdder;
